// Kept apart from cases/index so economy types can use it without importing
// the case domain.
export var CaseStatus;
(function (CaseStatus) {
    CaseStatus["PENDING"] = "PENDING";
    CaseStatus["VERIFIED"] = "VERIFIED";
    CaseStatus["ENDED"] = "ENDED";
})(CaseStatus || (CaseStatus = {}));
//# sourceMappingURL=status.js.map